export default __webpack_public_path__ + "static/media/java-spring-1.33252366.jpg";